import React from "react";
import { motion } from "framer-motion";
import { Clock } from "lucide-react";
const ComingSoon = () => {
  return (
    <section className="min-h-screen w-full bg-[#F6F8FC] flex items-center justify-center px-6 py-12">
      <div className="max-w-5xl w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-[32px] bg-gradient-to-br from-[#071A52] via-[#0B1F5C] to-[#102B75] text-white shadow-2xl"
        >
          <div className="absolute top-[-80px] right-[-80px] w-72 h-72 bg-[#FFD700]/20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-[-100px] left-[-80px] w-72 h-72 bg-white/10 rounded-full blur-3xl"></div>
          <div className="relative z-10 p-8 md:p-14 text-center">
            <div className="mx-auto mb-6 w-24 h-24 md:w-28 md:h-28 rounded-full bg-white flex items-center justify-center shadow-xl">
              <img
                src="/logo.png"
                alt="College Logo"
                className="w-20 h-20 md:w-24 md:h-24 object-contain"
              />
            </div>
            <span className="inline-flex items-center gap-2 bg-[#FFD700] text-[#071A52] px-5 py-2 rounded-full text-xs font-black uppercase tracking-wide mb-5">
              <Clock size={16} />
              Coming Soon
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
export default ComingSoon;